import { gql } from '@apollo/client'

export const DELETE_IMAGE = gql`
  mutation DeleteImage($imageId: ID!, $imageType: ImageType!) {
    deleteImage(imageId: $imageId, imageType: $imageType) {
      deleted
    }
  }
`
